<template>
    <div class="rounded shadow bg-grey-bg">
        <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
            <h3 class="flex-grow text-base font-normal">Inventory</h3>

            <div class="flex-none">
                <router-link
                    v-if="canNew"
                    :to="newTo"
                    class="btn btn-sm btn-with-icon"
                >
                    <div class="flex items-center justify-center">
                        <base-svg
                            name="icon-add-circle"
                            class="w-6 h-6 md:mr-2"
                        />
                        <div class="hidden md:block">New Inventory</div>
                    </div>
                </router-link>
            </div>
        </header>

        <div
            v-if="meta.total === 0"
            class="p-3 italic text-center text-grey"
        >
            There's nothing here!
        </div>

        <div
            v-else
            class="p-3 -mt-3 md:p-6 md:-mt-6"
        >
            <inventories-list :inventories="data" />

            <div
                v-if="meta.last_page > meta.page"
                class="px-4 pt-3 pb-2 text-sm font-semibold bg-grey-bg text-grey-darker sm:px-6"
            >
                <base-more
                    :to="moreTo"
                    :count="meta.count"
                    :total="meta.total"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import InventoriesList from './inventories-list'

    export default {
        components: {
            InventoriesList
        },
        props: {
            data: {
                type: Array,
                required: true
            },
            meta: {
                type: Object,
                required: true
            },
            canNew: {
                type: Boolean,
                default: false
            },
            newTo: {
                type: Object,
                default () {
                    return {
                        name: this.$router.fix('dashboard.*.inventories.create')
                    }
                }
            },
            moreTo: {
                type: Object,
                default () {
                    return {
                        name: this.$router.fix('dashboard.*.inventories.index')
                    }
                }
            }
        }
    }
</script>
